import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { formatMoney } from './utils';

// TODO: get this one from a parameter rather than a system level map
const HEADER_MAPPING = {
    id: 'ID',
    guest: 'Guest',
    amount: 'Amount',
    type: 'Type',
    last4: 'Last 4 digit',
    note: 'Note',
    bookedAt: 'Booked on',
    company: 'Company',
    activities: 'Activities',
    accountTo: 'Account to',
    activity: 'Activity name',
    agent: 'Agent',
    booking_id: 'Booking ID',
    createdAt: 'Booked on',
    feeType: 'Fee type',
    feeName: 'Fee name',
    netPayout: 'Net USD',
    status: 'Status',
    paymentStatus: 'Payment status',
    tax: 'Tax',
    sumNet: 'Sum net',
    sumTax: 'Sum tax',
    agencyDiscount: 'Agency discount',
    vendorDiscount: 'Vendor discount',
    agencyDiscountName: 'Agency discount name',
    agencyDiscountAmount: 'Agency discount amount',
    vendorDiscountName: 'Vendor discount name',
    vendorDiscountAmount: 'Vendor discount amount',
    activityStart: 'Activity start time',
    importId: 'Import ID',
    importName: 'Activity name',
    importCompany: 'Company'
};

/**
 * Generate xlsx data from an array of objects
 * @param {array} data array of objects to convert to xlsx rows
 * @returns header fields from object keys and rows from values
 */
export const generateXlsxData = data => {
    if (!data || data.length === 0) {
        return [];
    }

    let newData = data;

    if (Object.keys(data[0]).includes('is_fee')) {
        newData = newData.map(e => {
            delete e.is_fee;
            return e;
        });
    }

    const headers = Object.keys(newData[0]).map(object => HEADER_MAPPING[object]);

    const rows = newData.map(element => {
        return Object.values(element).map(value => {
            if (Array.isArray(value)) {
                // handle discounts
                if (value[0]?.name === 'Vendor discount' || value[0]?.name === 'Agency discount') {
                    return formatMoney(Math.abs(value[0].net + value[0].tax));
                }
                return value.map(e => e.name).join('\n');
            }
            return value;
        });
    });

    return [headers, ...rows];
};

/**
 * Generate xlsx file and initiate download
 * @param {array} data array of objects to convert to xlsx rows
 */
export const exportToXlsx = (data, name) => {
    const fileType =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';

    const ws = XLSX.utils.aoa_to_sheet(generateXlsxData(data));
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'SheetJS');
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });

    const file = new Blob([excelBuffer], { type: fileType });
    name.includes('importable')
        ? FileSaver.saveAs(file, `${name}${fileExtension}`)
        : FileSaver.saveAs(file, `booking_${name}${fileExtension}`);
};

export const exportToCsv = (filename, rows) => {
    const processRow = function(row) {
        let finalVal = '';
        for (let j = 0; j < row.length; j++) {
            let innerValue = row[j] === null ? '' : row[j].toString();
            if (row[j] instanceof Date) {
                innerValue = row[j].toLocaleString();
            }
            let result = innerValue.replace(/"/g, '""');
            if (result.search(/("|,|\n)/g) >= 0) {
                result = `"${result}"`;
            }
            if (j > 0) {
                finalVal += ';';
            }
            finalVal += result;
        }
        return `${finalVal}\n`;
    };

    let csvFile = '';
    for (let i = 0; i < rows.length; i++) {
        csvFile += processRow(rows[i]);
    }

    const blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' });
    if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(blob, filename);
    } else {
        const link = document.createElement('a');
        if (link.download !== undefined) {
            // feature detection
            // Browsers that support HTML5 download attribute
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', filename);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
};
